import { RichText, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

const MergeTagMapTemplate = {
  siteName: 'locationsitename',
  siteAddress: 'locationaddress',
  siteCity: 'locationcity',
  siteState: 'locationstate',
  siteCountry: 'locationcountry',
  siteZipCode: 'locationzip',
};

type MergeTagKey = keyof typeof MergeTagMapTemplate;

const replaceValue = (originaValue: string, lookupObj: Record<string, string>): string => {
  const tags = Object.keys(lookupObj);
  let replacedValue = originaValue;
  tags.forEach((tag) => {
    const tagValue = lookupObj[tag] || '';
    replacedValue = replacedValue.replace(new RegExp(`\\[${tag}\\]`, 'g'), tagValue as string);
  });

  return replacedValue;
};

function studyLocationMergeFieldMap(rawObject: Record<string, string>): Record<string, string> {
  const keys = Object.keys(MergeTagMapTemplate);
  const lookupObj = keys.reduce<Record<string, string>>((Obj, key: MergeTagKey) => {
    Obj[key] = rawObject?.[MergeTagMapTemplate[key]] || '';
    return Obj;
  }, {});

  return lookupObj;
}

function formatContentWithMergetag(
  data: string,
  objectMap: ReturnType<typeof studyLocationMergeFieldMap>
) {
  const replacedData = replaceValue(data, objectMap);
  return replacedData;
}

const StudyLocationMergeTag: React.FC<{
  field: RichTextField;
  rawData: Record<string, string>;
  className?: string;
}> = (props) => {
  const lookupObj = studyLocationMergeFieldMap(props?.rawData);
  const newValue = formatContentWithMergetag(String(props.field.value), lookupObj);
  return (
    <RichText
      field={{ value: newValue, editable: props.field.editable }}
      className={props.className}
    />
  );
};

export { studyLocationMergeFieldMap, formatContentWithMergetag, StudyLocationMergeTag };
